import _ from "lodash";
export default (state: tcpinpoint.Lease[] = [], action: any) => {
	switch (action.type) {
		case "GET_LEASE_SUCCESS":
			return _.unionBy([action.resource], state, "id");
		case "GET_LEASES_SUCCESS":
			return _.unionBy(action.resource as tcpinpoint.Lease[], state, "id");
		case "CLEAR_SESSION":
			return [];
		default:
			return state;
	}
};
